'use client';

function shouldOmitFooter({
  primaryAction,
  secondaryAction
}) {
  return !((primaryAction == null ? void 0 : primaryAction.label) || (secondaryAction == null ? void 0 : secondaryAction.label));
}
export {
  shouldOmitFooter
};
